(function(){
  var t=document.getElementById('bsTrack');
  if(t){document.querySelectorAll('.lv-bs-arrow').forEach(function(b){
    b.addEventListener('click',function(){
      t.scrollBy({left:t.clientWidth*0.85*parseInt(b.getAttribute('data-dir'),10),behavior:'smooth'});
    });
  });}
})();
(function(){
  document.querySelectorAll('.lv-swatches').forEach(function(row){
    row.addEventListener('click',function(e){
      var i=e.target.closest('i'); if(!i||!row.contains(i))return;
      row.querySelectorAll('i').forEach(function(x){x.classList.remove('lv-active');});
      i.classList.add('lv-active');
      var n=row.parentElement.querySelector('.lv-swname'); if(n)n.textContent=i.getAttribute('data-c')||'';
      var card=row.closest('.lv-card'), src=i.getAttribute('data-img');
      if(card&&src){
        var im=card.querySelector('.lv-imgwrap img');
        if(im){ im.style.opacity='0'; setTimeout(function(){ im.src=src; im.style.opacity='1'; },110); }
      }
    });
  });
})();

/* Showroom-Video: laeuft stumm von selbst los, sobald es im Blickfeld ist.
   Autoplay ist im Browser nur stumm erlaubt, das Video hat ohnehin keinen Ton.
   Wird Autoplay blockiert (Datensparmodus, reduzierte Bewegung, sehr langsame
   Verbindung), faellt es sauber auf den Play-Button zurueck. */
(function(){
  var box=document.querySelector('.lv-showroom-vis');
  if(!box)return;
  var vid=box.querySelector('video');
  if(!vid)return;
  var btn=box.querySelector('.lv-playbtn');
  var loaded=false;

  var conn=navigator.connection||{};
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noAuto=conn.saveData===true||reduce||/^(slow-2g|2g)$/.test(conn.effectiveType||'');

  function load(){
    if(loaded)return;
    loaded=true;
    var small=window.matchMedia('(max-width:749px)').matches;
    vid.src=(small&&vid.getAttribute('data-src-sm'))||vid.getAttribute('data-src');
    vid.load();
  }

  function autostart(){
    load();
    var p=vid.play();
    if(p&&p.then){
      p.then(function(){ box.classList.add('lv-playing','lv-auto'); })
       .catch(function(){ box.classList.remove('lv-playing','lv-auto'); });
    }else{
      box.classList.add('lv-playing','lv-auto');
    }
  }

  /* Fallback: Autoplay wurde blockiert, Klick startet manuell */
  function manual(){
    if(box.classList.contains('lv-auto'))return;
    load();
    box.classList.add('lv-playing');
    var p=vid.play();
    if(p&&p.catch)p.catch(function(){});
  }

  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){
          if(!noAuto)autostart(); else load();
          io.disconnect();
        }
      });
    },{rootMargin:'200px 0px',threshold:.15});
    io.observe(box);
  }else if(!noAuto){
    autostart();
  }

  box.addEventListener('click',function(e){
    if(box.classList.contains('lv-playing'))return;
    e.preventDefault(); manual();
  });
  if(btn)btn.addEventListener('keydown',function(e){
    if(e.key==='Enter'||e.key===' '){e.preventDefault();manual();}
  });
})();

/* Sticky-CTA auf dem Handy: erscheint erst, wenn der Hero (mit seinem eigenen
   Button) weggescrollt ist, und verschwindet wieder, sobald der Footer kommt.
   Sonst klebt er dauerhaft ueber Preisen und Inhalten. */
(function(){
  var cta=document.querySelector('.lv-mobcta');
  if(!cta)return;
  var hero=document.querySelector('.lv-hero');
  var foot=document.querySelector('.footer')||document.querySelector('.lv-seo');
  var heroIn=true, footIn=false;

  function upd(){
    var on=!heroIn && !footIn && window.innerWidth<=920;
    cta.classList.toggle('lv-show',on);
    document.body.classList.toggle('lv-cta-on',on);
  }

  if('IntersectionObserver' in window){
    if(hero){new IntersectionObserver(function(es){heroIn=es[0].isIntersecting;upd();},
      {threshold:0}).observe(hero);}
    if(foot){new IntersectionObserver(function(es){footIn=es[0].isIntersecting;upd();},
      {rootMargin:'0px 0px -12% 0px',threshold:0}).observe(foot);}
    upd();
  }else{
    cta.classList.add('lv-show');
    document.body.classList.add('lv-cta-on');
  }
  window.addEventListener('resize',upd,{passive:true});
})();
